/* global localStorage */
const SESSION_KEY = 'westmountSession'

const setSessionKey = (key) => localStorage.setItem(SESSION_KEY, key)
const getSessionKey = () => localStorage.getItem(SESSION_KEY)
const destroySessionKey = () => localStorage.removeItem(SESSION_KEY)

export { setSessionKey, getSessionKey, destroySessionKey }
